module.exports = __webpack_public_path__ + "static/img/acq-form-1.81b2e03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/acq-form-1.png
// module id = 2uOx
// module chunks = 1